import React from 'react';
import { Link } from 'react-router-dom';
import { FaEnvelope, FaPhone, FaMapMarkerAlt, FaLinkedin, FaInstagram, FaTwitter, FaArrowRight } from 'react-icons/fa';
import logo from '../assets/logo.png';

const services = [
  { label: 'EMS Solutions', to: '/ems-solutions' },
  { label: 'Manufacturing', to: '/manufacturing' },
  { label: 'Industries', to: '/industries' },
];

const company = [
  { label: 'About Us', to: '/about' },
  { label: 'Projects', to: '/projects' },
  { label: 'Contact Us', to: '/contact' },
];

export default function Footer() {
  return (
    <footer style={{ background:'#1a1a2e', color:'#e2e8f0' }}>

      {/* CTA */}
      <div style={{ background:'#5cb85c', padding:'40px 0' }}>
        <div className="wrap" style={{ display:'flex', flexWrap:'wrap', alignItems:'center', justifyContent:'space-between', gap:20 }}>
          <div>
            <h3 style={{ fontFamily:'Rajdhani', fontSize:26, fontWeight:700, color:'#fff', marginBottom:4 }}>
              Ready to start your next project?
            </h3>
            <p style={{ color:'rgba(255,255,255,0.88)', fontSize:15 }}>
              Saalfo Tech — Safer, Smarter & Sustainable electronics manufacturing.
            </p>
          </div>

          <Link to="/contact" style={{
            display:'inline-flex', alignItems:'center', gap:8,
            background:'#fff', color:'#3d8b3d', fontWeight:700,
            padding:'12px 28px', borderRadius:8,
            textDecoration:'none', fontSize:14
          }}>
            Contact Us <FaArrowRight size={13}/>
          </Link>
        </div>
      </div>

      {/* Main */}
      <div className="wrap" style={{ padding:'56px 24px 36px' }}>
        <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(200px,1fr))', gap:40, marginBottom:44 }}>

          {/* Brand */}
          <div>
            <img src={logo} alt="Saalfo Tech" style={{ height:40, marginBottom:16, filter:'brightness(1.3)' }}/>

            <p style={{ fontSize:14, color:'#94a3b8', lineHeight:1.7, marginBottom:18 }}>
              Saalfo Tech Pvt. Ltd.<br/>
              No. 123-127, Metagalli Industrial Area, Mysore-570016 Karnataka, India
            </p>

            <div style={{ display: 'flex', gap: 10 }}>
  <a
    href="https://linkedin.com/in/stpl-mysore"
    target="_blank"
    rel="noopener noreferrer"
    style={iconStyle}
  >
    <FaLinkedin size={14} />
  </a>

  <a
    href="https://www.instagram.com/saalfotech/"
    target="_blank"
    rel="noopener noreferrer"
    style={iconStyle}
  >
    <FaInstagram size={14} />
  </a>

  <a
    href="https://x.com/TechSaalfo"
    target="_blank"
    rel="noopener noreferrer"
    style={iconStyle}
  >
    <FaTwitter size={14} />
  </a>
</div>
          </div>

          {/* Company */}
          <div>
            <h4 style={headingStyle}>Company</h4>
            <ul style={listStyle}>
              {company.map(c => (
                <li key={c.to}>
                  <Link to={c.to} style={linkStyle}>
                    <span style={dotStyle}/>
                    {c.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 style={headingStyle}>Services</h4>
            <ul style={listStyle}>
              {services.map(s => (
                <li key={s.to}>
                  <Link to={s.to} style={linkStyle}>
                    <span style={dotStyle}/>
                    {s.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 style={headingStyle}>Contact</h4>

            {[
              { Icon: FaEnvelope, text:'info@saalfo.com', href:'mailto:info@saalfo.com' },
              { Icon: FaPhone, text:'+91 821 4244515', href:'tel:+918214244515' },
              { Icon: FaMapMarkerAlt, text:'Mysore, Karnataka, India' },
            ].map(({ Icon, text, href }, i) => (
              <div key={i} style={{ display:'flex', gap:10, marginBottom:12 }}>
                <Icon size={13} style={{ color:'#5cb85c', marginTop:2 }}/>
                {href
                  ? <a href={href} style={{ color:'#94a3b8', fontSize:14, textDecoration:'none' }}>{text}</a>
                  : <span style={{ color:'#94a3b8', fontSize:14 }}>{text}</span>
                }
              </div>
            ))}
          </div>
        </div>

        {/* Bottom */}
        <div style={{
          borderTop:'1px solid rgba(255,255,255,0.07)',
          paddingTop:24,
          display:'flex',
          flexWrap:'wrap',
          justifyContent:'space-between',
          gap:12
        }}>
          <p style={{ fontSize:13, color:'#64748b' }}>
            © {new Date().getFullYear()} Saalfo Tech Pvt Ltd. All rights reserved.
          </p>

          <div style={{ display:'flex', gap:6, flexWrap:'wrap' }}>
            {['ISO 9001:2015','ZED Bronze','MSME Certified','Make in India'].map(c => (
              <span key={c} style={badgeStyle}>{c}</span>
            ))}
          </div>
        </div>

        {/* Designed by */}
       <div style={{ textAlign:'center', marginTop:16 }}>
  <a 
    href="https://consolewaves.com/" 
    target="_blank" 
    rel="noopener noreferrer"
    style={{ color:'#f97316', fontSize:13, textDecoration:'none', fontWeight:600 }}
  >
    Designed by ConsoleWaves
  </a>
</div>

      </div>
    </footer>
  );
}

/* Styles */
const iconStyle = {
  width:32, height:32, borderRadius:7,
  background:'rgba(255,255,255,0.08)',
  display:'flex', alignItems:'center', justifyContent:'center',
  color:'#94a3b8', textDecoration:'none'
};

const headingStyle = {
  fontSize:11, fontWeight:700, letterSpacing:'.13em',
  textTransform:'uppercase', color:'#5cb85c', marginBottom:18
};

const listStyle = {
  listStyle:'none', display:'flex', flexDirection:'column', gap:11
};

const linkStyle = {
  color:'#94a3b8', textDecoration:'none',
  fontSize:14, display:'flex', alignItems:'center', gap:8
};

const dotStyle = {
  width:4, height:4, borderRadius:'50%',
  background:'#5cb85c', flexShrink:0
};

const badgeStyle = {
  fontSize:11, fontWeight:600, padding:'3px 10px',
  borderRadius:100, background:'rgba(92,184,92,0.12)',
  color:'#5cb85c', border:'1px solid rgba(92,184,92,0.2)'
};